import type { AuthUser } from './api'

const ADMIN_ROLES = ['ADMIN', 'AUX_ADMIN', 'SUPER_ADMIN', 'OWNER'] as const

function has(user: AuthUser | null | undefined, roles: readonly string[]) {
  if (!user) return false
  return roles.some(role => user.accountType === role || user.orgRole === role)
}

export function getDefaultRouteForUser(user: AuthUser | null | undefined): string {
  if (!user) return '/login'

  const t = user.accountType
  if (t === 'PLATFORM_OWNER') return '/platform-owner'
  if (t === 'DRIVER') return '/driver/app'
  if (t === 'DISPATCHER') return '/dispatcher'
  if (t === 'CARRIER_ADMIN') return '/carrier/dashboard'
  if (t === 'CARRIER_OPERATIONS') return '/carrier/dashboard'
  if (t === 'CUSTOMER') return '/q/wahatoya-auto-group'
  if (t === 'ACCOUNTING') return '/accounting'
  if (t === 'SALES_REQUESTOR') return '/orders'
  if (t === 'STORE_MANAGER') return '/orders'
  if (['BROKER_ADMIN', 'BROKER', 'BROKER_USER', 'DEALER', 'SHIPPER'].includes(t)) return '/loads'
  if (ADMIN_ROLES.includes(t as typeof ADMIN_ROLES[number])) return '/admin'

  return '/loads'
}

export function isDriverOnlyUser(user: AuthUser | null | undefined): boolean {
  if (!user) return false
  return has(user, ['DRIVER']) && !has(user, ['DISPATCHER', 'CARRIER_ADMIN', 'ACCOUNTING', ...ADMIN_ROLES])
}
